import React from 'react'
import { connect } from 'react-redux'
import Toggle from 'react-toggle'
import FileUploader from '../../Containers/FileUploader'
import PromoSectionActions from '../../Redux/PromoSectionRedux'

class UpdatePromoSection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        title: props.detail.title || '',
        subtitle: props.detail.subtitle || '',
        status: props.detail.status || '',
        url: props.detail.url || '',
        image_file: props.detail.image_file || '',
        content: props.detail.content || ''
      }
    }
  }

  _fileUploaded = (filename, field) => {
    let form = { ...this.state.form }
    form[field] = filename
    this.setState({ form })
  }

  _inputChange = (value, field) => {
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _toggleField = (value) => {
    let form = { ...this.state.form }
    if (value === 'active') {
      form['status'] = 'inactive'
    } else {
      form['status'] = 'active'
    }
    this.setState({ form })
  }

  _submitData = (event) => {
    event.preventDefault()
    let data = {
      id: this.props.detail.id,
      form: this.state.form
    }
    this.props.update(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Promo Section</h4>
        </div>
        <form onSubmit={event => this._submitData(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title</label>
            </div>
            <div className='col-9'>
              <input type='text' required className='form-control' value={this.state.form.title} onChange={event => this._inputChange(event.target.value, 'title')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Subtitle</label>
            </div>
            <div className='col-9'>
              <input type='text' className='form-control' value={this.state.form.subtitle} onChange={event => this._inputChange(event.target.value, 'subtitle')}  />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Content</label>
            </div>
            <div className='col-9'>
              <textarea
                required
                className='form-control'
                rows={5}
                value={this.state.form.content}
                onChange={event => this._inputChange(event.target.value, 'content')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Image</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'section-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Link URL</label>
              <small className='form-text text-muted'>URL must contain https://</small>
            </div>
            <div className='col-9'>
              <input type='text' required className='form-control' value={this.state.form.url} onChange={event => this._inputChange(event.target.value, 'url')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Active</label>
            </div>
            <div className='col-9'>
              <Toggle checked={this.state.form.status === 'active'} onChange={() => this._toggleField(this.state.form.status)} />
            </div>
          </div>
          <div className='text-right'>
            <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
            <button type='submit' className='btn btn-lg btn-primary'>Save</button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  promoSection: state.promoSection
})

const dispatchToProps = (dispatch) => ({
  update: (data) => dispatch(PromoSectionActions.updatePromoSectionRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdatePromoSection)



// WEBPACK FOOTER //
// ./src/Containers/Promo/UpdatePromoSection.js